import { actionTypes } from 'BASE/store/types';
import chatUtil from 'BASE/common/chat/chat.util';
import chatConstant from 'BASE/common/chat/chat.constant';
import CONSTANT from 'BASE/common/chat/chat.constant'
import marquee_component from 'WX/views/Marquee'
import downloadCenter_component from 'WX/views/Home/DownloadCenter';
import switchUrl_component from 'WX/views/SpeedTest/SwitchUrl';
import userFeedback_component from 'WX/views/Feedback';
import GoExternalGame from 'BASE/components/externalGame/externalGame.go.component';
import * as gameMenu from 'BASE/common/menu/menu.game';
import lotteryConstant from 'BASE/common/lotteryConstant';
import marginInfo_component from 'WX/views/ProportionalDividend/ProportionalDividend.marginInfo';
import audiovisual from 'BASE/components/audiovisual/audiovisual.component';

export default {
    data: function () {
        return {
            activedTab: undefined,
            gameMenus: {},
            vrMenus: {},
            showRightMenu:true,
        };
    },
    mixins: [GoExternalGame,audiovisual],
    computed: {
        gameDatas() {
            return this.$store.state.lottoinfo.data;
        },
        isAgent(){
            return this.$store.state.userinfo.isAgent;
        },
        isTransferPointEnabled(){
            return this.$store.state.userinfo.privileges.isTransferPointEnabled;
        },
        isSuperTransferPointEnabled(){
            return this.$store.state.userinfo.privileges.isSuperTransferPointEnabled;
        },
        userName() {
            return this.$store.state.userinfo.userName;
        },
        walletAmount() {
            return this.$store.state.userinfo.walletAmount;
        },
        systemRoomUnreadCount() {
            if(this.$store.state.chat)
            {
                let _room = this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.SYSTEM);
                if(_room)
                    return _room.unreadCount;
            }
                
            return 0;
        },
        customerServiceRoomUnreadCount() {
            if(this.$store.state.chat)
            {
                let _room = this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.CUSTOMER_SERVICE);
                if(_room)
                    return _room.unreadCount;
            }

            return 0;
        },
        topMenu() {
            return gameMenu.mergeInfo(this.gameMenus.homeTop, [this.gameDatas]);   //目前後台menu名固定
        },
        marksixMenu() {
            let homeBottomMenu = gameMenu.mergeInfo(this.gameMenus.homeBottom, [this.gameDatas]);
            return homeBottomMenu && homeBottomMenu[1] && homeBottomMenu[1].Items || [];
        },
        hideWalletAmount(){
            return this.$store.state.userinfo.hideWalletAmount;
        },
        audioMuted(){
            return this.$store.state.userinfo.audioMuted;
        },
        isDemoSite(){
            return this.$store.state.userinfo.IsDemoSite;
        },
    },
    components: {
        marquee_component,
        downloadCenter_component,
        switchUrl_component,
        userFeedback_component,
        marginInfo_component,
    },
    methods: {
        clickTab(newTab) {
            if (newTab === this.activedTab) {
                this.closeTab();
                return;
            }
            this.activedTab = newTab;
        },
        closeTab(){
            this.activedTab = undefined;
        },
        async refreshAmount() {
            await this.$store.dispatch(actionTypes.USER_INFO_WALLET_AMOUNT);
            if (this.$refs.marginInfo) {
                await this.$refs.marginInfo.refresh();
            }
        },
        openCustomerServiceChat() {
            if (this.$store.state.chat && this.$store.state.chat.userId) {
                let _roomId = chatUtil.getRoomId(chatConstant.serverRoomType.CUSTOMER_SERVICE, this.$store.state.chat.userId);
                this.$store.dispatch(actionTypes.CHAT_OPEN_ROOM_WINDOW, {
                    roomId: _roomId
                });
            }
        },
        openSystemChat() {
            if (this.$store.state.chat && this.$store.state.chat.userId) {
                let _roomId = chatUtil.getRoomId(chatConstant.serverRoomType.SYSTEM, this.$store.state.chat.userId);
                this.$store.dispatch(actionTypes.CHAT_OPEN_ROOM_WINDOW, {
                    roomId: _roomId
                });
            }
        },
        showAnnouncement(id, index) {
            if(this.$parent && this.$parent.showAnnouncement)
            {
                this.$parent.showAnnouncement(id, index);
            }
        },
        showDownloadCenter() {
            if(this.$refs && this.$refs.DownloadCenter)
            {
                this.$refs.DownloadCenter.showDownloadCenter();
            }
        },
        showSwitchUrl() {
            let _this = this;
            let _dialog = _this.$dialog.get('SwitchUrl');
            if (_this.$refs && _this.$refs.SwitchUrlRetest) {
                _this.$refs.SwitchUrlRetest.retest();
            }
            _dialog.show();

            _dialog.$on('close', function () {
                _dialog.hide();
            });
        },
        showFeedback() {
            if(this.$refs && this.$refs.Feedback)
            {
                this.$refs.Feedback.showFeedback();
            }
        },
        switchHideWalletAmount(){
            let _hideWalletAmount = !this.hideWalletAmount;
            this.$store.dispatch(actionTypes.USER_INFO_HIDE_WALLET_AMOUNT, { hideWalletAmount: _hideWalletAmount });
        },
        switchAudioMuted(){
            let _audioMuted = !this.audioMuted;
            this.$store.dispatch(actionTypes.USER_INFO_AUDIO_MUTED, { audioMuted: _audioMuted });
        }
    },
    updated(){
        //等所有Vue的資料更新完才做綁定，彩票遊戲選單是動態產生
        let _this = this;
        $(".topMenuItem").unbind().click(function(){
            _this.closeTab();
        });
    },
    async mounted() {
        try {
            this.gameMenus = await gameMenu.get();
            // 取得VR彩票
            this.vrMenus = await this.getVRLottery();
        } catch (err) {
            this.$dialog.warning('加载失败');
        }

        document.addEventListener('click',e => {
            if(!this.$el.contains(e.target)){
                this.closeTab();
             }
         })
    },

    watch:{
        "$route.name": function (val, oldVal) {
            let _this = this;
            _this.showRightMenu = true;
            if(val == "DrawHistory"){
                _this.showRightMenu = false;
            }
        }
    }
};